<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M17.0142 7.85945H14.2147V7.55189C14.2147 6.68466 13.6035 6 12.874 6H11.5926C10.8434 6 10.2519 6.70748 10.2519 7.55189V7.85945H0.985761C0.433735 7.85945 0 8.38436 0 9.00055C0 9.61674 0.45345 10.1416 0.985761 10.1416H10.2519V10.4481C10.2519 11.2925 10.8631 12 11.5926 12H12.874C13.6232 12 14.2147 11.2925 14.2147 10.4481V10.1416H17.0142C17.5663 10.1416 18 9.61674 18 9.00055C18 8.38436 17.5466 7.85945 17.0142 7.85945Z"
    />
    <path
      d="M0.98576 13.8594H3.78532V13.5519C3.78532 12.6847 4.39649 12 5.12596 12H6.40745C7.15663 12 7.74808 12.7075 7.74808 13.5519V13.8594H17.0142C17.5663 13.8594 18 14.3844 18 15.0005C18 15.6167 17.5465 16.1416 17.0142 16.1416H7.74808V16.4481C7.74808 17.2925 7.13691 18 6.40745 18H5.12596C4.37678 18 3.78532 17.2925 3.78532 16.4481V16.1416H0.98576C0.433733 16.1416 0 15.6167 0 15.0005C0 14.3844 0.453449 13.8594 0.98576 13.8594Z"
    />
    <path
      d="M0.98576 1.85945H3.78532V1.55189C3.78532 0.684657 4.39649 0 5.12596 0H6.40745C7.15663 0 7.74808 0.707479 7.74808 1.55189V1.85945H17.0142C17.5663 1.85945 18 2.38436 18 3.00055C18 3.61674 17.5465 4.14164 17.0142 4.14164H7.74808V4.44811C7.74808 5.29252 7.13691 6 6.40745 6H5.12596C4.37678 6 3.78532 5.29252 3.78532 4.44811V4.14164H0.98576C0.433733 4.14164 0 3.61674 0 3.00055C0 2.38436 0.453449 1.85945 0.98576 1.85945Z"
    />
  </svg>
</template>
